module.exports = __webpack_public_path__ + "images/en-0f9cfe.png";